// @flow

import type { Action } from './store.type';

export const GET_METAFIELDS_REQUEST = 'GET_METAFIELDS_REQUEST';
type GET_METAFIELDS_REQUEST_TYPE = 'GET_METAFIELDS_REQUEST';

export const GET_METAFIELDS_SUCCESS = 'GET_METAFIELDS_SUCCESS';
type GET_METAFIELDS_SUCCESS_TYPE = 'GET_METAFIELDS_SUCCESS';

export const GET_METAFIELDS_FAILURE = 'GET_METAFIELDS_FAILURE';
type GET_METAFIELDS_FAILURE_TYPE = 'GET_METAFIELDS_FAILURE';

type MetafieldType = {
  namespace: string,
  key: string,
  appliesTo: Object,
  type: string
};

type MetafieldQuery = {
  namespace: string,
  key: string,
  type: {
    name: string,
    category: string,
  }
};

type GetMetafieldsSuccess = {
  data: Array<MetafieldType>,
  total: number
};

type GetMetafieldFailure = {
  error: any
};

type GetMetafieldsRequestAction = Action<GET_METAFIELDS_REQUEST_TYPE, null>;

type GetMetafieldsSuccessAction = Action<GET_METAFIELDS_SUCCESS_TYPE, GetMetafieldsSuccess>;

type GetMetafieldsFailureAction = Action<GET_METAFIELDS_FAILURE_TYPE, GetMetafieldFailure>;

// Create Metafield
export const CREATE_METAFIELD_REQUEST = 'CREATE_METAFIELD_REQUEST';
type CREATE_METAFIELD_REQUEST_TYPE = 'CREATE_METAFIELD_REQUEST';

export const CREATE_METAFIELD_SUCCESS = 'CREATE_METAFIELD_SUCCESS';
type CREATE_METAFIELD_SUCCESS_TYPE = 'CREATE_METAFIELD_SUCCESS';

export const CREATE_METAFIELD_FAILURE = 'CREATE_METAFIELD_FAILURE';
type CREATE_METAFIELD_FAILURE_TYPE = 'CREATE_METAFIELD_FAILURE';

type CreateMetafieldRequestAction = Action<CREATE_METAFIELD_REQUEST_TYPE, null>;

type CreateMetafieldSuccessAction = Action<CREATE_METAFIELD_SUCCESS_TYPE, CreateMetafieldSuccess>;

type CreateMetafieldFailureAction = Action<CREATE_METAFIELD_FAILURE_TYPE, CreateMetafieldFailure>;

// Delete Metafield
export const DELETE_METAFIELD_REQUEST = 'DELETE_METAFIELD_REQUEST';
type DELETE_METAFIELD_REQUEST_TYPE = 'DELETE_METAFIELD_REQUEST';

export const DELETE_METAFIELD_SUCCESS = 'DELETE_METAFIELD_SUCCESS';
type DELETE_METAFIELD_SUCCESS_TYPE = 'DELETE_METAFIELD_SUCCESS';

export const DELETE_METAFIELD_FAILURE = 'DELETE_METAFIELD_FAILURE';
type DELETE_METAFIELD_FAILURE_TYPE = 'DELETE_METAFIELD_FAILURE';

type DeleteMetafieldRequestAction = Action<DELETE_METAFIELD_REQUEST_TYPE, null>;

type DeleteMetafieldSuccessAction = Action<DELETE_METAFIELD_SUCCESS_TYPE, DeleteMetafieldSuccess>;

type DeleteMetafieldFailureAction = Action<
  DELETE_METAFIELD_FAILURE_TYPE,
  DeleteMerchandisingFailure
>;

// Update Metafield
export const UPDATE_METAFIELD_REQUEST = 'UPDATE_METAFIELD_REQUEST';
type UPDATE_METAFIELD_REQUEST_TYPE = 'UPDATE_METAFIELD_REQUEST';

export const UPDATE_METAFIELD_SUCCESS = 'UPDATE_METAFIELD_SUCCESS';
type UPDATE_METAFIELD_SUCCESS_TYPE = 'UPDATE_METAFIELD_SUCCESS';

export const UPDATE_METAFIELD_FAILURE = 'UPDATE_METAFIELD_FAILURE';
type UPDATE_METAFIELD_FAILURE_TYPE = 'UPDATE_METAFIELD_FAILURE';

type UpdateMetafieldRequestAction = Action<UPDATE_METAFIELD_REQUEST_TYPE, null>;

type UpdateMetafieldSuccessAction = Action<UPDATE_METAFIELD_SUCCESS_TYPE, UpdateMetafieldSuccess>;

type UpdateMetafieldFailureAction = Action<UPDATE_METAFIELD_FAILURE_TYPE, UpdateMetafieldFailure>;

// Query Metafield
export const QUERY_METAFIELD_REQUEST = 'QUERY_METAFIELD_REQUEST';
type QUERY_METAFIELD_REQUEST_TYPE = 'QUERY_METAFIELD_REQUEST';

export const QUERY_METAFIELD_SUCCESS = 'QUERY_METAFIELD_SUCCESS';
type QUERY_METAFIELD_SUCCESS_TYPE = 'QUERY_METAFIELD_SUCCESS';

export const QUERY_METAFIELD_FAILURE = 'QUERY_METAFIELD_FAILURE';
type QUERY_METAFIELD_FAILURE_TYPE = 'QUERY_METAFIELD_FAILURE';

type QueryMetafieldRequestAction = Action<QUERY_METAFIELD_REQUEST_TYPE, null>;

export type QueryMetafieldSuccess = {
  data: Array<MetafieldType>,
};

export type QueryMetafieldFailure = {
  error: any
};

type QueryMetafieldSuccessAction = Action<QUERY_METAFIELD_SUCCESS_TYPE, QueryMetafieldSuccess>;

type QueryMetafieldFailureAction = Action<QUERY_METAFIELD_FAILURE_TYPE, QueryMetafieldFailure>;

// Query Type Metafields
export const QUERY_TYPE_METAFIELDS_REQUEST = 'QUERY_TYPE_METAFIELDS_REQUEST';
type QUERY_TYPE_METAFIELDS_REQUEST_TYPE = 'QUERY_TYPE_METAFIELDS_REQUEST';

export const QUERY_TYPE_METAFIELDS_SUCCESS = 'QUERY_TYPE_METAFIELDS_SUCCESS';
type QUERY_TYPE_METAFIELDS_SUCCESS_TYPE = 'QUERY_TYPE_METAFIELDS_SUCCESS';

export const QUERY_TYPE_METAFIELDS_FAILURE = 'QUERY_TYPE_METAFIELDS_FAILURE';
type QUERY_TYPE_METAFIELDS_FAILURE_TYPE = 'QUERY_TYPE_METAFIELDS_FAILURE';

type QueryTypeMetafieldsRequestAction = Action<QUERY_TYPE_METAFIELDS_REQUEST_TYPE, null>;

export type QueryTypeMetafieldsSuccess = {
  data: Array<MetafieldType>,
  total: number,
};

export type QueryTypeMetafieldsFailure = {
  error: any,
};

type QueryTypeMetafieldsSuccessAction = Action<QUERY_TYPE_METAFIELDS_SUCCESS_TYPE, QueryTypeMetafieldsSuccess>;

type QueryTypeMetafieldsFailureAction = Action<QUERY_TYPE_METAFIELDS_FAILURE_TYPE, QueryTypeMetafieldsFailure>;

// Action and State
export type MetafieldAction =
  | GetMetafieldsRequestAction
  | GetMetafieldsSuccessAction
  | GetMetafieldsFailureAction
  | CreateMetafieldRequestAction
  | CreateMetafieldSuccessAction
  | CreateMetafieldFailureAction
  | DeleteMetafieldRequestAction
  | DeleteMetafieldSuccessAction
  | DeleteMetafieldFailureAction
  | UpdateMetafieldRequestAction
  | UpdateMetafieldSuccessAction
  | UpdateMetafieldFailureAction
  | QueryMetafieldRequestAction
  | QueryMetafieldSuccessAction
  | QueryMetafieldFailureAction
  | QueryTypeMetafieldsRequestAction
  | QueryTypeMetafieldsSuccessAction
  | QueryTypeMetafieldsFailureAction;

export type MetafieldState = {
  loading: boolean,
  saving: boolean,
  deleting: boolean,
  reordering: boolean,
  scheduleSyncIn: number,
  scheduleSyncAfter: number,
  waitSyncAt: number,

  success: boolean,
  error: null,
  metafields: Array<MetafieldType>,
  total: number,
  queryingKey: string | null,
  querying: boolean,
  queriedMetafield: MetafieldQuery,
  typeMetafields: Array<MetafieldQuery>,
};
